import * as uploadFileActionCreator from "./uploadFileActionCreator";

export function defaultUploadFileState() {
    return {
      Loading: false,
      Response: null,
      Error: null,
    };
  }
  /**
   * User Reducer its take state and action
   * @param state
   * @param action
   */

  export const UploadFileReducer = (state, action) => {
    if (
      !state ||
      action.type === uploadFileActionCreator.FILE_ACTION.RESET_UPLOAD_FILE_STATE
    ) {
      return { ...state, ...defaultUploadFileState() };
    }
  
    if (action.type === uploadFileActionCreator.FILE_ACTION.REQUEST) {
      return { ...state, Loading: true };
    }
  
    if (action.type === uploadFileActionCreator.FILE_ACTION.RESPONSE) {
      return { ...state, Response: action.data, Loading: false };
    }
  
    if (action.type === uploadFileActionCreator.FILE_ACTION.ERROR) {
      return { ...state, Error: action.data, Loading: false };
    }
  
    return state; 
  };

  export function getFileState(){
    return {
      loading: false,
      response: null,
      error: null,
    };
  }

  export const FileReducer = (state, action) => {
    if (
      !state ||
      action.type === uploadFileActionCreator.GETFILE_ACTION.RESET_FILE_STATE
    ) {
      return { ...state, ...getFileState() };
    }
  
    if (action.type === uploadFileActionCreator.GETFILE_ACTION.REQUEST) {
      return { ...state, loading: true };
    }
  
    if (action.type === uploadFileActionCreator.GETFILE_ACTION.RESPONSE) {
      return { ...state, response: action.data, loading: false };
    }
  
    if (action.type === uploadFileActionCreator.GETFILE_ACTION.ERROR) {
      return { ...state, error: action.data, loading: false };
    }
  
    return state; 
  };

  export function downloaFileState(){
    return {
      loading: false,
      response: null,
      error: null,
      action:null
    };
  }
  export const DownloadFileReducer = (state, action) => {
    if (
      !state ||
      action.type === uploadFileActionCreator.DOWNLOADFILE_ACTION.RESET_FILE_STATE
    ) {
      return { ...state, ...downloaFileState() };
    }
  
    if (action.type === uploadFileActionCreator.DOWNLOADFILE_ACTION.REQUEST) {
      return { ...state, loading: true ,action :action.data.action };
    }
  
    if (action.type === uploadFileActionCreator.DOWNLOADFILE_ACTION.RESPONSE) {
      return { ...state, response: action.data, loading: false };
    }
  
    if (action.type === uploadFileActionCreator.DOWNLOADFILE_ACTION.ERROR) {
      return { ...state, error: action.data, loading: false };
    }
  
    return state; 
  };

